'use strict';

(function () {
	angular.module('app').filter('nwDisplayName', function () {
		return function (input) {
			return input && (input.displayName || input.name) || '';
		};
	});
})();